import styled from "styled-components"
import { SecondaryHeading } from "../../../heading.component"
import { BackgroundWrapper } from "../../section.component"
import { Image } from "../../../image.component"
import { Swiper } from "swiper/react"
import { StyledControlsButtonWrapper } from "../../../text-with-embed-carousel-stock/text-with-embed-carousel-stock"

export const StoreTypesWrapper = styled.div`
  width: 100%;
  /* display: grid;
  grid-template-columns: auto;
  text-align: left;

  @media (min-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    grid-template-columns: auto auto;
  } */
`

export const ContentWrapper = styled.div``

export const StoreName = styled.p`
  font-family: ${({ theme }) => theme.font.display};
  min-width: max-content;
  font-weight: 500;
  font-size: 23px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
`

export const SingleStoreWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  justify-content: space-around;

  margin: 60px 0 80px 0;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
  }
`

export const SingleStore = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`

export const SingleStoreType = styled(Swiper)`
  max-width: 860px;
  position: relative;
  /* margin-right: 40px; */

  /* ${SecondaryHeading} {
    @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
      margin-top: 50px;
      margin-bottom: 30px;
    }
  } */
`

export const Details = styled.p`
  margin-top: 0;
  word-wrap: break-word;
`

export const StoresBackgroundWrapper = styled(BackgroundWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: flex-start;
  padding-top: 80px;
  padding-bottom: 80px;
  grid-row-gap: 0;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    padding-top: 64px;
    padding-bottom: 64px;
  }
`

export const StoresImage = styled(Image)`
  margin-left: auto;
  margin-right: auto;
  border-radius: 10px;
  img {
    margin-bottom: 60px;
    height: calc(100vw - 40px);
    width: calc(100vw - 40px);
    top: 7%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    width: 255px;
    height: 255px;

    img {
      top: 0;
      border-radius: 10px;
      width: 255px;
      height: 255px;
    }
  }
`
